export enum PerformType {
    Activity,
    Protocol
}
